const SENSITIVITY_LABELS: Record<number, string> = {
  [-10]: 'Abstain',
  1: 'High Risk',
  2: 'Medium Risk',
  3: 'Low Risk',
};

export const transformSensitivity = (value?: number | null): string => (value == null ? '' : (SENSITIVITY_LABELS[value] ?? ''));
